export const FINISH_STARTUP = 'FINISH_STARTUP';
export const WS_CONNECTED = 'WS_CONNECTED';
export const WS_DISCONNECTED = 'WS_DISCONNECTED';
